




import Vue from 'vue';
import WaitlistCard from '@/components/UI/WaitlistCard.vue';
import { REACTIVATION_WAITLIST_SIGNUP } from '@/store/action-types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'ReactivationWaitlistCard',
  components: {
    WaitlistCard,
  },
  data() {
    return {
      REACTIVATION_WAITLIST_SIGNUP,
    };
  },
  computed: {
    ...mapGetters(['reactivationWaitlist']),
  },
});
